module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "om-paginator__list flex wrap sb"
  }, [(_vm.page > 1) ? _c('li', {
    staticClass: "om-paginator__prev om-paginator__page",
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.page - 1)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pagesCount > 1) ? _c('li', {
    staticClass: "om-paginator__page",
    class: [_vm.page === 1 ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.changeAction(1)
      }
    }
  }, [_vm._v(_vm._s(1))]) : _vm._e(), _vm._v(" "), (_vm.beforeDots) ? _c('li', {
    staticClass: "om-paginator__page om-paginator__dots"
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l(((_vm.spread * 2 + 1)), function(n) {
    return (n + _vm.page - (_vm.spread * 2) + 1 < _vm.pagesCount && n + _vm.page - (_vm.spread * 2) > 0) ? _c('li', {
      staticClass: "om-paginator__page",
      class: [_vm.page === (n + _vm.page - (_vm.spread * 2) + 1) ? 'active' : ''],
      on: {
        "click": function($event) {
          _vm.changeAction(n + _vm.page - (_vm.spread * 2) + 1)
        }
      }
    }, [_vm._v(_vm._s(n + _vm.page - (_vm.spread * 2) + 1))]) : _vm._e()
  }), _vm._v(" "), (_vm.afterDots) ? _c('li', {
    staticClass: "om-paginator__page om-paginator__dots"
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), (_vm.pagesCount >= 2) ? _c('li', {
    staticClass: "om-paginator__page",
    class: [_vm.page === _vm.pagesCount ? 'active' : ''],
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.pagesCount)
      }
    }
  }, [_vm._v(_vm._s(_vm.pagesCount))]) : _vm._e(), _vm._v(" "), (_vm.page < _vm.pagesCount) ? _c('li', {
    staticClass: "om-paginator__next om-paginator__page",
    on: {
      "click": function($event) {
        return _vm.changeAction(_vm.page + 1)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f62e49f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/paginator/Paginator.vue
// module id = 287
// module chunks = 1